<template>
  <el-form
      ref="form"
      :model="form"
      :inline="true"
      :disabled="disabled"
      hide-required-asterisk>
    <!-- <div class="title">分时调整预算</div> -->

    <div>
      <gj-alert type="warning" show-icon>
        <template #title>
          <div>以上三种分时规则不需都填写，分时执行时仅执行已填写的规则；</div>
          <div>当应用对象为广告活动时，适用三种分时规则，当应用对象为广告组或投放时，仅适用“调整竞价”规则。</div>
        </template>
      </gj-alert>
    </div>

    <div style="margin-top: 15px;">
      <el-form-item
          style="margin-right: 10px;">
        <gj-checkbox v-model="form.globalSet">启用</gj-checkbox>
      </el-form-item>
      <el-form-item
          label="超出每日预算时"
          style="margin-right: 10px;">
        <gj-select
            v-model="form.adjustType"
            :options="AdStrategyEnum.budgetForm.adjustTypeOption"
            :clearable="false"
            :size="size"
            width="100px"
        ></gj-select>
      </el-form-item>
      <el-form-item
          v-if="form.adjustType === AdStrategyEnum.budgetForm.adjustType.PERCENT_ADD"
          prop="adjustPercent"
          :rules="[{ required: dailyBudgetNeedValid, message: '请输入百分比', trigger: ['change'] }]"
          style="margin-right: 10px;">
        <gj-input
            v-model="form.adjustPercent"
            placeholder="请输入"
            :size="size"
            width="110px">
          <template v-if="form.adjustType === AdStrategyEnum.budgetForm.adjustType.PERCENT_ADD" #append>%</template>
        </gj-input>
      </el-form-item>
      <el-form-item
          v-if="form.adjustType === AdStrategyEnum.budgetForm.adjustType.VALUE_ADD"
          prop="adjustValue"
          :rules="[
            { required: dailyBudgetNeedValid, message: '请输入数值', trigger: ['change'] },
            dailyBudgetNeedValid ? $gjReRule(RE.num(2), '2位小数的整数') : {required: false}
          ]"
          style="margin-right: 10px;">
        <gj-input
            v-model="form.adjustValue"
            placeholder="请输入"
            :size="size"
            width="90px">
        </gj-input>
        <span class="el-form-item__label" style="margin-left: 10px;">次日00:00自动恢复到原预算</span>
      </el-form-item>
      <el-form-item
          v-if="form.adjustType === AdStrategyEnum.budgetForm.adjustType.PERCENT_ADD"
          label="最多增加"
          prop="limit"
          :rules="[
            { required: dailyBudgetNeedValid, message: '请输入数值', trigger: ['change'] },
            dailyBudgetNeedValid ? $gjReRule(RE.num(2), '2位小数的整数') : {required: false}
          ]"
          style="margin-right: 10px;">
        <gj-input
            v-model="form.limit"
            placeholder="请输入"
            :size="size"
            width="90px">
        </gj-input>
        <span class="el-form-item__label" style="margin-left: 10px;">次日00:00自动恢复到原预算</span>
      </el-form-item>
    </div>

    <gj-table
        :index="false"
        name="adjustBudgetStrategyForm"
        :data="form.items"
        :columns="columns"
        :adapt-height="false"
        :height="352"
        style="margin-bottom: 12px;"
        :show-overflow="false"
    >
      <template v-slot:header:strategy>
        每日预算
        <gj-help popperClass="gj-tooltip--500" class="gj-help">
            预算增加%：计算出调整值和最多增加值对比，大于最多增加值，使用原始预算+最多增加值作为预算目标值，小于最多增加值，使用原始预算+计算出的调整值作为预算目标值。如预算增加50%，最多增加$40，原始预算为$100，100*0.5=50>40，则预算调整为$140=100+40，最多增加$60，50&lt;60，则预算调整为$150=100+100*0.5。
        </gj-help>
      </template>
      <template v-slot:triggerType="{ index }">
        <el-form-item
            :prop="`items.${index}.triggerType`"
            :rules="[
              { required: true, message: '请选择触发类型', trigger: ['change'] },
            ]"
            class="gj-table-item">
          <gj-select
              v-model="form.items[index].triggerType"
              :options="AdStrategyEnum.triggerTypeOption"
              :clearable="false"
              :disabled="form.globalSet"
              :size="size">
          </gj-select>
        </el-form-item>
      </template>

      <template v-slot:repeat="{ index }">
        <el-form-item
            :prop="`items.${index}.repeat`"
            :rules="[
              { required: budgetDailiesNeedValid, message: '请选择重复周期', trigger: ['change'] },
            ]"
            class="gj-table-item">
          <gj-select
              v-model="form.items[index].repeat"
              :options="form.items[index].repeatOption"
              multiple
              width="280px"
              :disabled="form.globalSet"
              :clearable="false"
              :size="size"
              @input="repeatInput(form.items[index], form.items[index].repeatOption)">
          </gj-select>
        </el-form-item>
      </template>

      <template v-slot:time="{ index }">
        <el-form-item
            :prop="`items.${index}.startTime`"
            :rules="[
              { required: budgetDailiesNeedValid, message: '请选择开始时间', trigger: ['change'] },
            ]"
            class="gj-table-item"
            style="margin-right: 10px;">
          <gj-time-select
              v-model="form.items[index].startTime"
              :picker-options="{
                ...AdStrategyEnum.timeOption,
                maxTime: form.items[index].endTime
              }"
              placeholder="开始时间"
              :clearable="false"
              :disabled="form.globalSet"
              :size="size"
          ></gj-time-select>
        </el-form-item>
        <el-form-item
            :prop="`items.${index}.endTime`"
            :rules="[
              { required: budgetDailiesNeedValid, message: '请选择结束时间', trigger: ['change'] },
            ]"
            class="gj-table-item">
          <gj-time-select
              v-model="form.items[index].endTime"
              :picker-options="{
                ...AdStrategyEnum.timeOption,
                minTime: form.items[index].startTime
              }"
              :clearable="false"
              :disabled="form.globalSet"
              placeholder="结束时间"
              :size="size"
          ></gj-time-select>
        </el-form-item>
      </template>

      <template v-slot:strategy="{ index }">
        <el-form-item
            :prop="`items.${index}.adjustType`"
            :rules="[
              { required: budgetDailiesNeedValid, message: '请选择调整类型', trigger: ['change'] },
            ]"
            class="gj-table-item"
            style="margin-right: 10px;">
          <gj-select
              v-model="form.items[index].adjustType"
              :options="AdStrategyEnum.adjustForm.adjustTypeOption"
              :clearable="false"
              :filterable="false"
              placeholder="请选择"
              :size="size"
              :disabled="form.globalSet"
              width="110px"
          ></gj-select>
        </el-form-item>
        <el-form-item
            v-if="form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD
              || form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB"
            :prop="`items.${index}.adjustPercent`"
            :rules="[
              { required: budgetDailiesNeedValid, message: '请输入百分比', trigger: ['change'] },
              budgetDailiesNeedValid ? $gjReRule(RE.pt0, '请输入正整数') : {required: false}
            ]"
            class="gj-table-item"
            style="margin-right: 10px;">
          <gj-input
              v-model="form.items[index].adjustPercent"
              placeholder="请输入"
              :size="size"
              width="73px"
              :disabled="form.globalSet"
              :clearable="false">
            <!--            <template #append>%</template>-->
          </gj-input>
        </el-form-item>
        <el-form-item
            v-if="form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.VALUE_ADD
              || form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.VALUE_SUB
              || form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.VALUE_FIXED"
            :prop="`items.${index}.adjustValue`"
            :rules="[
              { required: budgetDailiesNeedValid, message: '请输入数值', trigger: ['change'] },
              budgetDailiesNeedValid ? $gjReRule(RE.num(2), '最多两位小数的正数') : {required: false}
            ]"
            class="gj-table-item"
            style="margin-right: 10px;">
          <gj-input
              v-model="form.items[index].adjustValue"
              placeholder="请输入"
              :size="size"
              :disabled="form.globalSet"
              width="110px">
          </gj-input>
        </el-form-item>
        <el-form-item
            v-if="form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD
              || form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB"
            :prop="`items.${index}.limit`"
            :rules="[ $gjReRule(RE.num(2), '最多两位小数的正数') ]"
            class="gj-table-item"
            style="margin-right: 10px;">
          <template #label>
            <template v-if="form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB">
              最低调整到
            </template>
            <template v-if="form.items[index].adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD">
              最多调整
            </template>
          </template>
          <gj-input
              v-model="form.items[index].limit"
              placeholder="选填"
              :size="size"
              :disabled="form.globalSet"
              width="110px">
          </gj-input>
        </el-form-item>
      </template>

      <template v-slot:op="{ index, row }">
        <gj-button
            type="iconfont"
            iconfont="iconzengjia"
            size="20px"
            :disabled="form.globalSet"
            @click="addItem(index, row)"
            >
        </gj-button>
        <gj-button
            type="iconfont"
            iconfont="iconjianshao"
            size="20px"
            v-if="form.items.length > 1"
            :disabled="form.globalSet"
            @click="deleteItem(index)"
            >
        </gj-button>
      </template>
    </gj-table>

    <div>
      <gj-alert type="info" show-icon>
        <template #title>
          <div>分时调整可调整广告活动每日预算,根据设定的对象进行调整。</div>
          <div>使用分时调预算过程中，如果手动修改预算或在亚马逊后台修改预算，分时调预算会以最后手动修改的预算为原预算。不在调整时间范围内，系统自动恢复原预算。</div>
        </template>
      </gj-alert>
      <!--      <p>{{form | json}}</p>-->
    </div>
  </el-form>
</template>

<script>
  import {formDeleteItemMixin, formRuleMixin} from "../../../../../../../../minxins";
  import {OpEnum} from "../../../../../../../../utils/options";
  import {AdStrategyEnum} from "../../../../common/enum";
  import {isMeaningful, isMeaningless} from "../../../../../../../../utils/common";

  export default {
    name: "app-adjust-budget-strategy-form",
    mixins: [formDeleteItemMixin, formRuleMixin],
    props: {
      form: {
        required: true
      },
      disabled: {
        type: Boolean,
        required: true
      },
      initForm$: {
        required: true
      }
    },
    created() {

    },
    data() {
      return {
        columns: [
          {id: 'triggerType', header: '触发类型', field: 'slot:triggerType', width: '120px'},
          {id: 'repeat', header: '重复周期', field: 'slot:repeat', minWidth: '280px'},
          {id: 'time', header: '站点时间', field: 'slot:time', width: '250px'},
          {id: 'strategy', header: 'slot:strategy', field: 'slot:strategy', minWidth: '450px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '90px', notCustomColumn: true},
        ],
        size: 'default',
        AdStrategyEnum: AdStrategyEnum,
      }
    },
    watch: {
      initForm$: {
        handler: function (init) {
          if (isMeaningful(init) || isMeaningless(this.form.items) || this.form.items.length === 0) {
            this.form.items = [];
            this.addItem();
          }
        },
        immediate: true
      }
    },
    computed: {
      dailyBudgetInitState() {
        return isMeaningless(this.form.globalSet) || !this.form.globalSet;
      },
      //启用  勾选 true   不勾选 false
      dailyBudgetNeedValid() {
        return !this.dailyBudgetInitState;
      },
      // 校验items
      budgetDailiesInitState() {
        //若 启用 已勾选，则不校验下方表格
        if(this.dailyBudgetNeedValid){
          return true;
        }
        if (isMeaningless(this.form.items) || this.form.items.length === 0 ) {
          return true;
        }
        if (this.form.items.length === 1) {
          const item = this.form.items[0];
          return (isMeaningless(item.repeat) || item.repeat.length === 0)
            && isMeaningless(item.startTime)
            && isMeaningless(item.endTime)
              && (((item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_ADD || item.adjustType === AdStrategyEnum.adjustForm.adjustType.PERCENT_SUB) && isMeaningless(item.adjustPercent) && isMeaningless(item.limit))
                  || ((item.adjustType === AdStrategyEnum.adjustForm.adjustType.VALUE_ADD || item.adjustType === AdStrategyEnum.adjustForm.adjustType.VALUE_SUB || item.adjustType === AdStrategyEnum.adjustForm.adjustType.VALUE_FIXED || item.adjustType ==='')
                      && isMeaningless(item.adjustValue)))
        }
        return false
      },
      budgetDailiesNeedValid() {
        return !this.budgetDailiesInitState;
      }
    },
    methods: {
      addItem(index = -1, row = null) {
        this.form.items.splice(index + 1, 0, {
          triggerType: row ? row.triggerType : AdStrategyEnum.triggerType.time,
          adjustType: row ? row.adjustType : '',
          adjustValue: row ? row.adjustValue : null,
          adjustPercent: row ? row.adjustPercent : null,
          repeat: row ? row.repeat : [],
          repeatOption: AdStrategyEnum.repeatOption.map(item => ({
            ...item
          })),
          limit: row ? row.limit : null,
          startTime: row ? row.endTime : null,
          endTime: null
        });
      },
      repeatInput(item, repeatOption) {
        if (item.repeat.includes(0)) {
          // 包含每天，禁用周一至周日
          item.repeat = [0];
          repeatOption.forEach(option => {
            if (option.id !== 0) {
              option.disabled = true;
            }
          });
        } else {
          repeatOption.forEach(option => {
            option.disabled = false;
          });
        }
      },
      formValidate() {
        if (this.dailyBudgetNeedValid || this.budgetDailiesNeedValid) {
          return this.$gjFormValidate();
        }
        return true;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "common";
  /deep/.gj-table--default td:not(.vxe-footer--column) {
    &.vxe-body--column {
        height: 58px !important;
      }
  }
</style>
